import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a06c225"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeydown"]
const _hoisted_2 = ["aria-describedby"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "ltp-trigger-btn"
}, "Hover me", -1))
const _hoisted_4 = { class: "ltp-content" }
const _hoisted_5 = {
  key: 0,
  class: "ltp-title"
}
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = {
  key: 0,
  class: "ltp-arrow",
  "aria-hidden": "true"
}

import { ref, computed, onMounted, onBeforeUnmount } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LingoTooltipComponent',
  props: {
  text: { type: String, default: "This is a tooltip" },
  supporting: { type: String, default: "" },
  placement: { type: String as () => "top" | "bottom" | "left" | "right", default: "top" },
  align: { type: String as () => "start" | "center" | "end", default: "center" },
  openOnClick: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  showArrow: { type: Boolean, default: true },
},
  setup(__props) {

const props = __props;

let idInc = 0;



const open = ref(false);
const tooltipId = `ltp-${++idInc}`;

const wrapper = ref<HTMLElement | null>(null);
const trigger = ref<HTMLElement | null>(null);
const tooltip = ref<HTMLElement | null>(null);

const placement = computed(() => props.placement);
const align = computed(() => props.align);
const text = computed(() => props.text);
const supporting = computed(() => props.supporting);
const showArrow = computed(() => props.showArrow);

const tooltipStyle = computed(() => {
  // keep placeholder for potential positioning calculations
  return {} as Record<string, string>;
});

function onEnter() {
  if (props.disabled) return;
  open.value = true;
}

function onLeave() {
  open.value = false;
}

function toggle() {
  if (props.disabled) return;
  open.value = !open.value;
}

function close() {
  open.value = false;
}

onMounted(() => {
  if (props.openOnClick && trigger.value) {
    (trigger.value as HTMLElement).addEventListener("click", toggle);
  }
});

onBeforeUnmount(() => {
  if (props.openOnClick && trigger.value) {
    (trigger.value as HTMLElement).removeEventListener("click", toggle);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ltp-wrapper",
    onMouseleave: onLeave,
    onKeydown: _withKeys(_withModifiers(close, ["prevent"]), ["esc"]),
    ref_key: "wrapper",
    ref: wrapper
  }, [
    _createElementVNode("span", {
      class: "ltp-trigger",
      ref_key: "trigger",
      ref: trigger,
      onMouseenter: onEnter,
      onFocus: onEnter,
      onBlur: onLeave,
      "aria-describedby": open.value ? tooltipId : undefined
    }, [
      _renderSlot(_ctx.$slots, "trigger", {}, () => [
        _hoisted_3
      ])
    ], 40, _hoisted_2),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["ltp", [`ltp--${placement.value}`, `ltp-align--${align.value}`, supporting.value ? 'ltp--with-support' : 'ltp--no-support']]),
      id: tooltipId,
      role: "tooltip",
      style: _normalizeStyle(tooltipStyle.value),
      ref_key: "tooltip",
      ref: tooltip
    }, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.$slots.default)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(text.value), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: "ltp-title",
                textContent: _toDisplayString(text.value)
              }, null, 8, _hoisted_6),
              (supporting.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "ltp-support",
                    textContent: _toDisplayString(supporting.value)
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      (showArrow.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8))
        : _createCommentVNode("", true)
    ], 6), [
      [_vShow, open.value]
    ])
  ], 40, _hoisted_1))
}
}

})